module.exports = __webpack_public_path__ + "593a3d53/img/verified-icon.f93bbc14.svg";